// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__HpRJ-","header":"MergedInvoice_header__1hkHE"};